/* Order List, Vue Component */
<template>
  <div>
    <v-card id="order-list">
      <v-card-title>Find Order To Book-In Item</v-card-title>

      <v-card-text class="d-flex align-center flex-wrap pb-0">

        <div class="d-flex align-center pb-5 flex-wrap w-100">

          <!-- <v-text-field v-model="search.Reference"
          dense
          outlined
          hide-details
          label="Search Reference"
          class="mb-4 mr-4"
        ></v-text-field> -->
          <v-text-field v-model="search.MemberId_Reference" dense outlined hide-details label="Member Reference"
            class="mb-4 mr-4"></v-text-field>

          <v-text-field v-model="search.MemberId_FullName" dense outlined hide-details label="Member Name"
            class="mb-4 mr-4"></v-text-field>

          <v-spacer></v-spacer>

          <v-text-field v-model="search.all" dense outlined hide-details label="Search All"
            class="mb-4 mr-4 ml-auto"></v-text-field>

          <v-btn color="primary" class="mb-4 mr-4 ml-auto" @click="searchData">
            Search
          </v-btn>

        </div>
      </v-card-text>

      <!-- table -->
      <v-data-table v-model="selectedItems" :headers="tableColumns" :items="items" :options.sync="options"
        :server-items-length="totalItems" :loading="loading" :footer-props="footerProps" class="text-no-wrap">

        <template #[`item.Reference`]="{ item }">
          <router-link class="font-weight-medium text-decoration-none"
            :to="{ name: 'order-view', params: { id: item.Id } }">
            {{ item.Reference }}
          </router-link>

        </template>


        <template #[`item.MemberId_Reference`]="{ item }">
          <strong>{{ item.MemberId_Reference }}</strong>
        </template>

        <template #[`item.ProductId_Price`]="{ item }">
          {{ Display.Money(item.ProductId_Price) }}
        </template>

        <template #[`item.StatusId_Name`]="{ item }">
          <order-status-chip :status="item.StatusId_Name"></order-status-chip>
        </template>

        <template #[`item.ItemDescription`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="text-overflow-ellipses" style="width: 180px;">{{ item.ItemDescription
                }}</div>
            </template>
            <span>{{ item.ItemDescription }}</span>
          </v-tooltip>
        </template>

        <template #[`item.DeliveryAddressId_Summary`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="text-overflow-ellipses" style="width: 180px;">{{
                item.DeliveryAddressId_Summary }}</div>
            </template>
            <span>{{ item.DeliveryAddressId_Summary }}</span>
          </v-tooltip>
        </template>

        <template #[`item.actions`]="{ item }">
          <div class="d-flex align-center justify-left">
            <v-btn color="success" small :to="{ name: 'order-bookitem', params: { id: item.Id } }">Book Item</v-btn>
          </div>
        </template>

      </v-data-table>

      <v-data-table v-model="selectedItems" :headers="tableColumns" :items="extraItemsFiltered" :options.sync="extraOptions"
        :server-items-length="extraTotalItems" :loading="loading" :footer-props="footerProps" class="text-no-wrap"
        v-if="extraItemsFiltered.length > 0">

        <template #[`item.Reference`]="{ item }">
          <router-link class="font-weight-medium text-decoration-none"
            :to="{ name: 'order-view', params: { id: item.Id } }">
            {{ item.Reference }}
          </router-link>

        </template>


        <template #[`item.MemberId_Reference`]="{ item }">
          <strong>{{ item.MemberId_Reference }}</strong>
        </template>

        <template #[`item.ProductId_Price`]="{ item }">
          {{ Display.Money(item.ProductId_Price) }}
        </template>

        <template #[`item.StatusId_Name`]="{ item }">
          <order-status-chip :status="item.StatusId_Name"></order-status-chip>
        </template>

        <template #[`item.ItemDescription`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="text-overflow-ellipses" style="width: 180px;">{{ item.ItemDescription
                }}</div>
            </template>
            <span>{{ item.ItemDescription }}</span>
          </v-tooltip>
        </template>

        <template #[`item.DeliveryAddressId_Summary`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="text-overflow-ellipses" style="width: 180px;">{{
                item.DeliveryAddressId_Summary }}</div>
            </template>
            <span>{{ item.DeliveryAddressId_Summary }}</span>
          </v-tooltip>
        </template>

        <template #[`item.actions`]="{ item }">
          <div class="d-flex align-center justify-left">
            <v-btn color="success" small @click="duplicate(item.Id)">Duplicate
              Order</v-btn>
          </div>
        </template>

      </v-data-table>
    </v-card>

    <v-card class="mt-6">
      <v-card-text>
        <!-- <h3>MULTIPLE PACKAGE</h3>
        <p>If you think this item is part of an existing ready or held order, toggle the switch below to show those
          orders.
        </p>
        <v-switch v-model="readyAndHeld" label="Show Ready & Held orders" class="mb-4 mr-4" hide-details></v-switch> -->

        <h3>NO ORDER FOUND</h3>
        <p>If you are sure the item does not belong to any of the orders, add it to a fresh order that
          will be held for review.</p>
        <v-btn color="error" small :to="{ name: 'member-findforbooking' }">Find Member</v-btn>
      </v-card-text>
    </v-card>
  </div>

</template>

<script>

import store from '@/store'
import { useRouter } from '@core/utils'
import {
  mdiPlus,
  mdiDeleteOutline,
  mdiEyeOutline,
  mdiPencilOutline,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarkedOutline,
} from '@mdi/js'

import { ref, watch, computed } from '@vue/composition-api'
import * as Validators from '@/datahelpers/validation'
import * as Display from '@/datahelpers/displayTypes'
import ActionsDropdown from '@/views/helpers/ActionsDropdown'
import OrderStatusSelect from '@/views/orderstatus/OrderStatusSelect'
import ProductSelect from '@/views/product/ProductSelect'
import ManifestSelect from '@/views/manifest/ManifestSelect'
//import MemberSelect from '@/views/member/MemberSelect'
import MemberLookup from '@/views/member/MemberLookup'
// import AddressSelect from '@/views/address/AddressSelect'
import OrderStatusChip from '@/views/orderstatus/OrderStatusChip'

export default {
  components: {
    ActionsDropdown,
    OrderStatusSelect,
    ProductSelect,
    ManifestSelect,
    //MemberSelect,
    MemberLookup,
    OrderStatusChip,
    // AddressSelect
  },
  setup() {

    const { route, router } = useRouter();

    // define cols
    const tableColumns = [
      {
        text: '',
        value: 'actions',
        align: 'center',
        sortable: false,
      },
      { text: 'Reference', value: 'Reference' },
      { text: 'Tracking Ref.', value: 'S10Tracking' },
      // { text: 'Member', value: 'MemberId_Reference' },
      { text: 'Member Name', value: 'MemberId_FullName' },
      { text: 'Product', value: 'OrderType' },
      { text: 'Description', value: 'ItemDescription' },

      { text: 'Ret. Ref.', value: 'RetailerReference' },
      // { text: 'Status', value: 'StatusId_Name' },
      { text: 'Delivery', value: 'DeliveryAddressId_Summary' },

    ];

    // threee params for fetching
    const search = ref({
      all: '',
      MemberId_Reference: '',
      MemberId_FullName: '',
    });
    const filter = ref({
      StatusIds: [1, 2],
      Bookin: true
    });
    const options = ref({
      sortBy: ['MemberId_Reference'],
      sortDesc: [false],
      itemsPerPage: 20,
      page: 1
    });
    const footerProps = {
      'items-per-page-options': [10, 20, 50, 100, -1]
    };

    // items
    const items = computed(() => store.state.app.Orders || []);
    const totalItems = computed(() => store.state.app.OrdersTotal || 0);
    const selectedItems = ref([]);
    const loading = ref(false);

    const extraItems = ref([]);
    const extraItemsFiltered = computed(() => extraItems.value.filter(item => !item.OriginalOrderId));
    const extraTotalItems = ref(0);
    const extraFilter = ref({
      StatusIds: [6, 7, 8, 10],
      Bookin: true
    });
    const extraOptions = ref({
      sortBy: ['MemberId_Reference'],
      sortDesc: [false],
      itemsPerPage: 20,
      page: 1
    });

    const hasPopulatedSearchFields = () => {
      if (search.value.all.length > 0) return true
      if (search.value.MemberId_Reference.length > 0) return true
      if (search.value.MemberId_FullName.length > 0) return true
      return false
    }

    // method for data loading via vuex
    const fetchData = () => {
      extraItems.value = []
      extraTotalItems.value = 0
      store
        .dispatch('app/fetchOrders', {
          search: search.value,
          options: options.value,
          filter: filter.value,
        })
        .then(response => {
          loading.value = false
          if (items.value.length < 10 && hasPopulatedSearchFields()) {
            fetchExtra()
          } else {
            extraItems.value = []
            extraTotalItems.value = 0
          }
        })
        .catch(error => {
          console.log(error)
        })
    }

    const fetchExtra = () => {
      store
        .dispatch('app/fetchExtraOrders', {
          search: search.value,
          options: extraOptions.value,
          filter: extraFilter.value,
        })
        .then(response => {
          extraItems.value = response.items
          extraTotalItems.value = response.total
        })
        .catch(error => {
          console.log(error)
        })
    }

    watch([options], () => {
      loading.value = true
      fetchData()
    }, { deep: true });

    watch([extraOptions], () => {
      fetchExtra()
    }, { deep: true });

    function searchData() {
      this.$set(this.options, 'page', 1);
      loading.value = true
      fetchData()
    }

    const booleanIcons = status => {
      if (status) return { variant: 'success', icon: mdiCheckboxMarkedOutline }
      return { variant: 'secondary', icon: mdiCheckboxBlankOutline }
    }

    const duplicate = (id) => {
      store
        .dispatch('app/duplicate', id)
        .then(response => {
          router.push({ name: 'order-bookitem', params: { id: response } });
        })
        .catch(error => {
          console.log(error)
        })
    }

    return {
      searchData,
      tableColumns,
      search,
      filter,
      options,
      totalItems,
      items,
      extraOptions,
      extraFilter,
      extraItems,
      extraItemsFiltered,
      extraTotalItems,
      loading,
      selectedItems,
      footerProps,
      booleanIcons,
      Validators,
      Display,
      duplicate,
      icons: {
        mdiPlus
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
